import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Router} from '@angular/router';
import {finalize, Observable, take} from 'rxjs';
import {tap, shareReplay} from 'rxjs/operators';
import {DialogService} from "./dialog.service";
import {SharedHelper} from "../helpers/shared.helper";
import {ModalTemplates} from "../enums/modal-templates";
import {ModalTypes} from "../enums/modal-types";
import {SpinnerService} from './spinner.service';
import {RouterLinks} from "../enums/router-links";

//import { catchError } from 'rxjs/operators';
// import {NgxSpinnerService} from "ngx-spinner";

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {
  count = 0;
  private global_texts: any;
  timeout: number = 0;

  constructor(
    public router: Router,
    public dialogService: DialogService,
    public sharedHelper: SharedHelper,
    public spinnerService: SpinnerService,
  ) {
    this.sharedHelper.getGlobalTexts().subscribe((texts) => {
      this.global_texts = texts;
    });
  }

  cache = new Map<string, Observable<HttpEvent<any>>>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> | undefined {
    const cacheKey = req.urlWithParams;
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey);
    }
    this.spinnerService.show();
    this.count++;
    const request = next.handle(req)
      .pipe(
        tap({
          next: (event) => {
            //console.log(event)
          },
          error: (error: any) => {
            console.log("error ==> ", error);

            // Error API
            if (error.status !== 401 && error.status !== 999) {
              this.dialogService.confirmThis(
                (error?.error?.error_message) ? '' : this.global_texts?.modals?.error_api?.title,
                (error?.error?.error_message) ? error.error.error_message : this.global_texts?.modals?.error_api?.message,
                ModalTypes.Alert,
                ModalTemplates.Default,
                () => {
                },
                () => {
                }
              );
              return;
            }

            // Redirection vers login
            if(sessionStorage.getItem('session_token') === null) {
              this.router.navigate([RouterLinks.Login]);
              return;
            }

            // Session expired
            this.dialogService.confirmThis(
              (error?.error?.error_message) ? '' : this.global_texts?.modals?.expired_session?.title,
              (error?.error?.error_message) ? error.error.error_message : this.global_texts?.modals?.expired_session?.message,
              ModalTypes.Alert,
              (error?.error?.error_message) ? ModalTemplates.Default : ModalTemplates.SessionExpired,
              () => {
                //localStorage.clear();
                sessionStorage.clear();
                this.router.navigate([RouterLinks.Login]);
              },
              () => {
              }
            );
          }
        }),
        finalize(() => {
          this.count--;

          let timeout = (window.location.pathname === '/') ? 1200 : 0;

          if (this.count == 0) {
            setTimeout(() => {
              this.spinnerService.hide()
            }, timeout);
          }

          this.cache.delete(cacheKey);
        }),
        shareReplay(1)
      );

    this.cache.set(cacheKey, request);

    return request;
  }
}
